var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  })
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("router.investmentForm"), active: "" } },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.customerList.Description1
                                  ? _vm.customerList.Description1
                                  : "",
                                "text",
                                "insert.investmentForm.customer"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.customerList.CommercialTitle
                                  ? _vm.customerList.CommercialTitle
                                  : "",
                                "text",
                                "insert.investmentForm.customerName"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.customerList.CustomerLocations &&
                                  _vm.customerList.CustomerLocations.length > 0
                                  ? _vm.customerList.CustomerLocations[0]
                                      .AddressDetail
                                  : "",
                                "text",
                                "insert.investmentForm.address"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.customerList.LicenseNumber
                                  ? _vm.customerList.LicenseNumber
                                  : "",
                                "text",
                                "insert.investmentForm.licenseNumber"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Description1
                                  ? _vm.rowData.Description1
                                  : "",
                                "text",
                                "insert.investmentForm.description"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.Type
                                  ? _vm.rowData.Type.Label
                                  : null,
                                "text",
                                "insert.investmentForm.typeId"
                              )
                            )
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.customerList.RouteDetails &&
                                  _vm.customerList.RouteDetails.length > 0
                                  ? _vm.customerList.RouteDetails[0].Route.Label
                                  : "",
                                "text",
                                "insert.investmentForm.route"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.customerList.RouteDetails &&
                                  _vm.customerList.RouteDetails.length > 0
                                  ? _vm.customerList.RouteDetails[0]
                                      .Representative.Label
                                  : "",
                                "text",
                                "insert.investmentForm.tmrSrName"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.ContractValidDates &&
                                  _vm.rowData.ContractValidDates.length > 0
                                  ? _vm.rowData.ContractValidDates[0]
                                      .CreatedDateTime
                                  : "",
                                "text",
                                "insert.investmentForm.formDate"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                this.form.salesVolumeClass
                                  ? this.form.salesVolumeClass
                                  : "",
                                "text",
                                "insert.investmentForm.salesVolumeClass"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.customerList.CustomerRegion5
                                  ? _vm.customerList.CustomerRegion5.Label
                                  : "",
                                "text",
                                "insert.investmentForm.customerArea"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getFormatDataByType(
                                _vm.rowData.SignatureType
                                  ? _vm.rowData.SignatureType.Label
                                  : "",
                                "text",
                                "insert.investmentForm.signingType"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.investmentForm.currentInvestment")
                }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.investmentForm.contractDates")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "p-1" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "NextFormGroup",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "insert.investmentForm.contractStartDate"
                                          )
                                        }
                                      },
                                      [
                                        _c("NextDatePicker", {
                                          attrs: { disabled: true },
                                          model: {
                                            value:
                                              _vm.contractDates
                                                .ContractValidDateStartDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.contractDates,
                                                "ContractValidDateStartDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "contractDates.ContractValidDateStartDate"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c(
                                      "NextFormGroup",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "insert.investmentForm.contractEndDate"
                                          )
                                        }
                                      },
                                      [
                                        _c("NextDatePicker", {
                                          attrs: { disabled: true },
                                          model: {
                                            value:
                                              _vm.contractDates
                                                .ContractValidDateEndDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.contractDates,
                                                "ContractValidDateEndDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "contractDates.ContractValidDateEndDate"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "NextFormGroup",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "insert.investmentForm.contractDuration"
                                          )
                                        }
                                      },
                                      [
                                        _c("NextInput", {
                                          attrs: {
                                            disabled: true,
                                            type: "text"
                                          },
                                          model: {
                                            value:
                                              _vm.daysDifferenceCurrentInvestment,
                                            callback: function($$v) {
                                              _vm.daysDifferenceCurrentInvestment = $$v
                                            },
                                            expression:
                                              "daysDifferenceCurrentInvestment"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.investmentForm.currentSales")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th"),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              this.currentSales.KentBrandLC
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              this.currentSales.RothmansBrandLC
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              this.currentSales.Tekel2000BrandLC
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.total"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.currentMonthlyAverageSale"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales.KentNetSales
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales.RothmansNetSales
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales
                                                .Tekel2000NetSales
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales.KentNetSales +
                                                this.currentSales
                                                  .RothmansNetSales +
                                                this.currentSales
                                                  .Tekel2000NetSales
                                            ) + " "
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.currentAnnualSaleProfit"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales.KentNetSales *
                                                this.GrossMargin
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales
                                                .RothmansNetSales *
                                                this.GrossMargin
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales
                                                .Tekel2000NetSales *
                                                this.GrossMargin
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales.KentNetSales *
                                                this.GrossMargin +
                                                this.currentSales
                                                  .RothmansNetSales *
                                                  this.GrossMargin +
                                                this.currentSales
                                                  .Tekel2000NetSales *
                                                  this.GrossMargin
                                            ) + " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.investmentForm.currentInvestmentBudget"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.contractGainType"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.earningAmount"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.earningsTypeBudget"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.contract.plannedPaymentDate"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [_vm._v("Nakit")]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetCash
                                                .Cash
                                                ? this
                                                    .currentInvestmentBudgetCash
                                                    .Cash
                                                : "-----"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetCash
                                                .cashBudgetMaster
                                                ? this
                                                    .currentInvestmentBudgetCash
                                                    .cashBudgetMaster
                                                : "-----"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetCash
                                                .cashScheduledPaymentDate
                                                ? this
                                                    .currentInvestmentBudgetCash
                                                    .cashScheduledPaymentDate
                                                : "-----"
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [_vm._v("Only DTI")]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetDTI
                                                .OnlyDTI
                                                ? this
                                                    .currentInvestmentBudgetDTI
                                                    .OnlyDTI
                                                : "-----"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetDTI
                                                .dtiBudgetMaster
                                                ? this
                                                    .currentInvestmentBudgetDTI
                                                    .dtiBudgetMaster
                                                : "-----"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td")
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [_vm._v("YYM")]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetYYM
                                                .Yym
                                                ? this
                                                    .currentInvestmentBudgetYYM
                                                    .Yym
                                                : "-----"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetYYM
                                                .yymBudgetMaster
                                                ? this
                                                    .currentInvestmentBudgetYYM
                                                    .yymBudgetMaster
                                                : "-----"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td")
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.total"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentInvestmentBudgetCash
                                                .Cash +
                                                this.currentInvestmentBudgetDTI
                                                  .OnlyDTI +
                                                this.currentInvestmentBudgetYYM
                                                  .Yym
                                            )
                                          ),
                                          _c("span", [_c("b-td")], 1)
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td"),
                                        _vm._v(" "),
                                        _c("b-td")
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.investmentForm.currentReturnOnInvestment"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-tbody",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.currentReturnOnInvestmentTL"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.currentSales.KentNetSales *
                                                this.GrossMargin +
                                                this.currentSales
                                                  .RothmansNetSales *
                                                  this.GrossMargin +
                                                this.currentSales
                                                  .Tekel2000NetSales *
                                                  this.GrossMargin -
                                                (this.currentInvestmentBudget
                                                  .KentContractQuotaQuantity +
                                                  this.currentInvestmentBudget
                                                    .RothmansContractQuotaQuantity +
                                                  this.currentInvestmentBudget
                                                    .Tekel2000ContractQuotaQuantity)
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.rateOfReturnOnInvestment"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              (this.currentSales.KentNetSales *
                                                this.GrossMargin +
                                                this.currentSales
                                                  .RothmansNetSales *
                                                  this.GrossMargin +
                                                this.currentSales
                                                  .Tekel2000NetSales *
                                                  this.GrossMargin) /
                                                (this.currentInvestmentBudget
                                                  .KentContractQuotaQuantity +
                                                  this.currentInvestmentBudget
                                                    .RothmansContractQuotaQuantity +
                                                  this.currentInvestmentBudget
                                                    .Tekel2000ContractQuotaQuantity)
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.investmentForm.newInvestment") }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.investmentForm.contractDates")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "p-1" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "NextFormGroup",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "insert.investmentForm.contractStartDate"
                                          )
                                        }
                                      },
                                      [
                                        _c("NextDatePicker", {
                                          attrs: { disabled: true },
                                          model: {
                                            value:
                                              _vm.validDates.contractStartDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.validDates,
                                                "contractStartDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "validDates.contractStartDate"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c(
                                      "NextFormGroup",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "insert.investmentForm.contractEndDate"
                                          )
                                        }
                                      },
                                      [
                                        _c("NextDatePicker", {
                                          attrs: { disabled: true },
                                          model: {
                                            value:
                                              _vm.validDates.contractEndDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.validDates,
                                                "contractEndDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "validDates.contractEndDate"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "NextFormGroup",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "insert.investmentForm.contractDuration"
                                          )
                                        }
                                      },
                                      [
                                        _c("NextInput", {
                                          attrs: { disabled: true },
                                          model: {
                                            value:
                                              _vm.daysDifferenceNewInvestment,
                                            callback: function($$v) {
                                              _vm.daysDifferenceNewInvestment = $$v
                                            },
                                            expression:
                                              "daysDifferenceNewInvestment"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.investmentForm.targetSale")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th"),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              this.targetSale
                                                .KentBrandContractItem
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              this.targetSale
                                                .RothmansBrandContractItem
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              this.targetSale
                                                .Tekel2000BrandContractItem
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.total"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.targetedAverageMonthlySales"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.targetSale
                                                .kentMonthlyAverageSales
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.targetSale
                                                .rothmansMonthlyAverageSales
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.targetSale
                                                .tekelMonthlyAverageSales
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              parseInt(
                                                this.targetSale
                                                  .kentMonthlyAverageSales +
                                                  this.targetSale
                                                    .rothmansMonthlyAverageSales +
                                                  this.targetSale
                                                    .tekelMonthlyAverageSales
                                              )
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.targetAnnualSalesProfit"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.targetSale
                                                .KentContractItemQuotaQuantity
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.targetSale
                                                .RothmansContractItemQuotaQuantity
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.targetSale
                                                .Tekel2000ContractItemQuotaQuantity
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              parseInt(
                                                this.targetSale
                                                  .KentContractItemQuotaQuantity +
                                                  this.targetSale
                                                    .RothmansContractItemQuotaQuantity +
                                                  this.targetSale
                                                    .Tekel2000ContractItemQuotaQuantity
                                              )
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.investmentForm.newInvestmentBudget"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.contractGainType"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.earningAmount"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.earningsTypeBudget"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.contract.plannedPaymentDate"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  [
                                    _vm._l(
                                      _vm.rowData.ContractBenefits &&
                                        _vm.rowData.ContractBenefits.length > 0
                                        ? _vm.rowData.ContractBenefits.filter(
                                            function(c) {
                                              return c.BenefitTypeId === 3
                                            }
                                          )
                                        : [],
                                      function(c, i) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [_vm._v("Nakit")]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(c.BenefitBudget))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(c.BudgetMaster.Label)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(_vm.PlannedPaymentDate)
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      this.ContractPriceDiscountsDTI &&
                                        this.ContractPriceDiscountsDTI.length >
                                          0
                                        ? _vm.rowData.ContractBenefits.filter(
                                            function(c) {
                                              return c.BenefitTypeId === 6
                                            }
                                          )
                                        : [],
                                      function(c, i) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [_vm._v("Only DTI")]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(c.BenefitBudget))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(c.BudgetMaster.Label)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td")
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      this.ContractPriceDiscountsYYM &&
                                        this.ContractPriceDiscountsYYM.length >
                                          0
                                        ? _vm.rowData.ContractBenefits.filter(
                                            function(c) {
                                              return c.BenefitTypeId === 6
                                            }
                                          )
                                        : [],
                                      function(c, i) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [_vm._v("YYM")]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(c.BenefitBudget))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(c.BudgetMaster.Label)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td")
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.total"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.newInvestmentBudgetTotal
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td"),
                                        _vm._v(" "),
                                        _c("b-td")
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.investmentForm.newReturnOfInvestment"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-tbody",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.expectedProfitability"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              this.targetSale
                                                .KentContractItemQuotaQuantity +
                                                this.targetSale
                                                  .RothmansContractItemQuotaQuantity +
                                                this.targetSale
                                                  .Tekel2000ContractItemQuotaQuantity -
                                                this.newInvestmentBudgetTotal
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.expectedReturnOnInvestment"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              (this.targetSale
                                                .KentContractItemQuotaQuantity +
                                                this.targetSale
                                                  .RothmansContractItemQuotaQuantity +
                                                this.targetSale
                                                  .Tekel2000ContractItemQuotaQuantity -
                                                this.newInvestmentBudgetTotal /
                                                  this
                                                    .newInvestmentBudgetTotal) *
                                                100
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.investmentForm.unitAndOrderDetails")
                }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.investmentForm.currentUnitStatus"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.Units"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.unitName"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.piece"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.investmentForm.location"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    this.assetsLocationList.AssetLocations,
                                    function(c, i) {
                                      return _c(
                                        "b-tr",
                                        { key: i },
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.unit"
                                                ) +
                                                  (i + 1)
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(c.Asset.Label))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(c.Quantity))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(c.Customer.Label))
                                          ])
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.investmentForm.opponentUnitStatus"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [_c("span", [_vm._v("Firma")])]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.rowData.ContractOpponentAssets,
                                      function(c, i) {
                                        return _c("b-th", { key: i }, [
                                          _c("span", [
                                            _vm._v(_vm._s(c.Description1))
                                          ])
                                        ])
                                      }
                                    )
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  [
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.unit"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.rowData.ContractOpponentAssets,
                                          function(c, i) {
                                            return _c("b-td", { key: i }, [
                                              _vm._v(
                                                _vm._s(
                                                  c.IsAvailable &&
                                                    c.IsAvailable !== null &&
                                                    c.IsAvailable === 1
                                                    ? "Var"
                                                    : "Yok"
                                                )
                                              )
                                            ])
                                          }
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.unitType"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.rowData.ContractOpponentAssets,
                                          function(c, i) {
                                            return _c("b-td", { key: i }, [
                                              _vm._v(
                                                _vm._s(
                                                  c.OpponentAssetTypeId &&
                                                    c.OpponentAssetTypeId !==
                                                      null &&
                                                    c.OpponentAssetTypeId ===
                                                      2341
                                                    ? "Buyuk"
                                                    : "Kucuk" ||
                                                      (c.OpponentAssetTypeId &&
                                                        c.OpponentAssetTypeId ===
                                                          null)
                                                    ? ""
                                                    : "Kucuk"
                                                )
                                              )
                                            ])
                                          }
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tr",
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.investmentAmount"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.rowData.ContractOpponentAssets,
                                          function(c, i) {
                                            return _c("b-td", { key: i }, [
                                              _vm._v(
                                                _vm._s(
                                                  c.InvestmentTotal &&
                                                    c.InvestmentTotal > 0
                                                    ? c.InvestmentTotal
                                                    : ""
                                                )
                                              )
                                            ])
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "p-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "7" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.investmentForm.otherDetails")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              _vm._l(
                                _vm.rowData.ContractOtherDetailss,
                                function(c, i) {
                                  return _c(
                                    "b-tbody",
                                    { key: i },
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.furniteCost"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(c.FurnitureExpense))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.numberOfFrontFaces"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(c.ShelfQuantity))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.frontFaceCost"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(c.ShelfExpense))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.totalFurniteCost"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(c.TotalExpense))
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfa2d3bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfa2d3bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/InvestmentForm/get.vue
// module id = null
// module chunks = 